import { formatDateToCustomDateFormat } from 'lib/utils/date';

class SubscriptionCard {
  // eslint-disable-next-line complexity
  constructor(data = {}) {
    this.accountNumber = data.accountNumber || null;
    this.billTariff = data.billTariff || null;
    this.createdAt = data.createdAt || null;
    this.currency = data.currency || null;
    this.id = data.id || null;
    this.isActive = data.status === SubscriptionCard.statuses.ACTIVE;
    this.name = data.name || null;
    this.nextDeliverAt = data.nextDeliverAt && formatDateToCustomDateFormat(data.nextDeliverAt, 'DD.MM.YYYY');
    this.overallAmount = data.overallAmount;
    this.status = data.status || null;
  }

  static statuses = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
  }
}

export default SubscriptionCard;
